export const MY_SURVEYS_PATH = "/my-surveys";
